import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { DevoDonorsPageService } from '../devo-donors.page.service';
import { DevoDonorsDonorsViewPart } from './donors/devo-donors-donors-view.part';
import { DevoDonorsContactsViewPart } from './contacts/devo-donors-contacts-view.part';
import { DevoDonorsGiftsViewPart } from './gifts/devo-donors-gifts-view.part';


@Component({
	selector: 'devo-donors-views-part',
	standalone: true,
	imports: [
		DevoDonorsDonorsViewPart,
		DevoDonorsContactsViewPart,
		DevoDonorsGiftsViewPart,
		DroplistWidget,
		NgSwitch,
		NgSwitchCase
	],
	templateUrl: './devo-donors-views.part.html',
})
export class DevoDonorsViewsPart implements OnInit {
	public service = inject(DevoDonorsPageService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}